"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BannerComponent = exports.ROUTES = void 0;
const tslib_1 = require("tslib");
const core_api_1 = require("@ikegps/core-api");
const mobx_1 = require("mobx");
const i18n_1 = require("../../i18n");
const mithril_1 = require("../../mithril");
const department_selector_1 = require("../../modules/department.selector/department.selector");
const omni_search_1 = require("../../modules/omni.search/omni.search");
const change_settings_1 = require("../../modules/user/change.settings");
const page_1 = require("../../page/page");
const page_layout_1 = require("../../page/page.layout");
const services_1 = require("../../services");
const userDisplayName_1 = require("../../util/userDisplayName");
const image_button_1 = require("../button/image.button");
const icons_1 = require("../icon/icons");
const menu_1 = require("../menu/menu");
const menu_item_1 = require("../menu/menu.item");
const mithril_component_1 = require("../mithril.component");
const modal_service_1 = require("../modal/modal.service");
const theme_1 = require("../theme");
const banner_style_1 = require("./banner.style");
exports.ROUTES = {
    FORM_LIST: () => services_1.Services.Route.go(page_1.IkePageName.formList),
    ORG_SEARCH: () => services_1.Services.Route.go(page_1.IkePageName.orgSearch),
    ACCOUNTS: () => services_1.Services.Route.go(page_1.IkePageName.accountList),
    LOGOUT: () => services_1.Services.Route.go(page_1.IkePageName.logout)
};
class BannerComponent extends mithril_component_1.IMithrilComponent {
    constructor() {
        super();
        this.name = 'Banner';
        this.departmentSelector = new department_selector_1.DepartmentSelector();
        this.changeSettings = new change_settings_1.ChangeSettingsComponent();
        this.omniSearch = new omni_search_1.OmniSearch();
        this.menu = new menu_1.MenuComponent({
            items: () => this.viewMenuItems
        });
        this.helpmenu = new menu_1.MenuComponent({
            items: () => this.viewHelpMenuItems
        });
    }
    get nodes() {
        if (!services_1.Services.User.hasUser) {
            services_1.Services.User.logout();
            return null;
        }
        document.title = (0, i18n_1.Translate)(services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_IKE_OFFICE_PRO) ? i18n_1.T.IKE_OFFICE_PRO : i18n_1.T.IKE_OFFICE);
        const asset = services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_IKE_OFFICE_PRO) ? (0, theme_1.assetPath)('/images/Logo-IKE-Office-Pro.svg') : (0, theme_1.assetPath)('/images/Logo-IKE-Office.svg');
        const officeImg = (0, mithril_1.m)('img', { src: asset, alt: 'IKE Office Logo', style: 'height: 35px; margin-right: 5px;' });
        const isMap = services_1.Services.Route.active.config.name === page_1.IkePageName.map;
        return [
            (0, mithril_1.m)('header', { className: banner_style_1.CSS.header.container }, [
                (0, mithril_1.m)('div', { className: banner_style_1.CSS.header.row }, [
                    this.viewDrawerButton,
                    (0, mithril_1.m)('div', { className: banner_style_1.CSS.header.section }, [
                        (0, mithril_1.m)('span', { className: banner_style_1.MDL.title }, officeImg),
                        this.departmentSelector.view()
                    ]),
                    isMap ? this.omniSearch.view() : null,
                    (0, mithril_1.m)('div', { className: `${banner_style_1.CSS.header.section} ${banner_style_1.CSS.header.sectionRight}` }, [
                        this.helpmenu.view(),
                        image_button_1.ImageButton.view(icons_1.MaterialIcon.HELP_OUTLINE, { onclick: this.helpmenu.show, title: i18n_1.T.HELP_MENU }),
                        image_button_1.ImageButton.view(icons_1.MaterialIcon.PERSON, { onclick: this.menu.show, title: i18n_1.T.USER_MENU_SETTINGS }),
                        this.menu.view()
                    ])
                ])
            ])
        ];
    }
    get viewFormIcon() {
        return image_button_1.ImageButton.view(icons_1.MaterialIcon.CONTENT_PASTE, { onclick: exports.ROUTES.FORM_LIST, title: i18n_1.T.USER_MENU_FORM });
    }
    get viewSearchIcon() {
        if (!services_1.Services.Token.has(core_api_1.IkeToken.ORG_SEARCH_PAGE) && !services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_GROUP_IKE_ANALYZE)) {
            return null;
        }
        return image_button_1.ImageButton.view(icons_1.MaterialIcon.ORG_SEARCH, { onclick: exports.ROUTES.ORG_SEARCH, title: i18n_1.T.ORG_SEARCH });
    }
    get viewDrawerButton() {
        return image_button_1.ImageButton.view(icons_1.MaterialIcon.MENU, { onclick: () => page_layout_1.PageLayoutState.nav.setVisible(true), title: 'menu' });
    }
    get viewHelpMenuItems() {
        return [
            {
                view: this.viewHelpCard,
                component: true,
                disabled: true
            }, {
                view: menu_item_1.MenuItemComponent.view((0, i18n_1.Translate)(i18n_1.T.SUBMIT_SUPPORT_REQUEST)),
                action: () => window.open('https://support.ikegps.com/hc/en-us/requests/new?ticket_form_id=5786678993677'),
                visible: true
            }, {
                view: menu_item_1.MenuItemComponent.view((0, i18n_1.Translate)(i18n_1.T.SUPPORT_PORTAL)),
                action: () => window.open('https://support.ikegps.com'),
                visible: true
            }, {
                view: menu_item_1.MenuItemComponent.view((0, i18n_1.Translate)(i18n_1.T.RELEASE_NOTES)),
                action: () => window.open('https://ikegps.zendesk.com/hc/en-us/categories/16992245574541-Release-Notes'),
                visible: true
            }
        ];
    }
    get viewMenuItems() {
        return [
            {
                view: this.viewUserCard,
                component: true,
                disabled: true
            }, {
                view: menu_item_1.MenuItemComponent.view((0, i18n_1.Translate)(i18n_1.T.USER_MENU_ACCOUNTS)),
                action: exports.ROUTES.ACCOUNTS,
                visible: services_1.Services.Token.has(core_api_1.IkeToken.COMPANY_ACCOUNTS)
            }, {
                view: menu_item_1.MenuItemComponent.view((0, i18n_1.Translate)(i18n_1.T.USER_MENU_SETTINGS)),
                action: () => this.openChangeSettings()
            }, {
                view: menu_item_1.MenuItemComponent.view((0, i18n_1.Translate)(i18n_1.T.USER_MENU_CHANGE_PASSWORD)),
                action: () => this.openChangePassword(),
                divider: true
            }, {
                view: menu_item_1.MenuItemComponent.view((0, i18n_1.Translate)(i18n_1.T.USER_MENU_LOGOUT)),
                action: exports.ROUTES.LOGOUT
            }
        ].filter(Boolean);
    }
    get viewUserCard() {
        const currentUser = services_1.Services.User.current;
        if (currentUser == null) {
            return null;
        }
        const displayName = (0, userDisplayName_1.userDisplayName)(currentUser);
        return (0, mithril_1.m)('div', { className: banner_style_1.CSS.user.card, onclick: e => e.stopPropagation() }, [
            (0, mithril_1.m)('div', { className: banner_style_1.CSS.user.name }, displayName),
            displayName !== currentUser.username ? (0, mithril_1.m)('div', { className: banner_style_1.CSS.user.email }, currentUser.username) : null
        ]);
    }
    get viewHelpCard() {
        return (0, mithril_1.m)('div', { className: banner_style_1.CSS.user.card, onclick: e => e.stopPropagation() }, [
            (0, mithril_1.m)('div', { className: banner_style_1.CSS.user.name }, (0, i18n_1.Translate)(i18n_1.T.HELP_MENU))
        ]);
    }
    openChangeSettings() {
        this.changeSettings.open();
    }
    openChangePassword() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const result = yield modal_service_1.ModalService.open({
                title: (0, i18n_1.Translate)(i18n_1.T.PASSWORD_CHANGE_PASSWORD),
                content: (0, mithril_1.m)('div', (0, i18n_1.Translate)(i18n_1.T.PASSWORD_CHANGE_PASSWORD_DETAIL)),
                hasCancel: true,
                okName: i18n_1.T.SEND
            });
            if (result.ok) {
                yield services_1.Services.SSO.resetPassword();
                const okResult = yield modal_service_1.ModalService.open({
                    title: (0, i18n_1.Translate)(i18n_1.T.PASSWORD_CHANGE_PASSWORD),
                    content: (0, i18n_1.Translate)(i18n_1.T.PASSWORD_RESET_EMAIL_SENT),
                    okName: i18n_1.T.LOGOUT
                });
                if (okResult.ok) {
                    services_1.Services.SSO.logout(true);
                }
            }
        });
    }
}
exports.BannerComponent = BannerComponent;
tslib_1.__decorate([
    mobx_1.computed
], BannerComponent.prototype, "nodes", null);
//# sourceMappingURL=banner.js.map